import { render, staticRenderFns } from "./UnderDevelopment.vue?vue&type=template&id=70654820&scoped=true"
import script from "./UnderDevelopment.vue?vue&type=script&lang=js"
export * from "./UnderDevelopment.vue?vue&type=script&lang=js"
import style0 from "./UnderDevelopment.vue?vue&type=style&index=0&id=70654820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70654820",
  null
  
)

export default component.exports